import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import { observer } from 'mobx-react'
import DocumentTitle from 'react-document-title'

import ExpertPage from '@root/Expert/ExpertPage'
import ExpertSearchPanel from './ExpertSearchPanel'

class ExpertSearchPage extends Component {
  render () {
    return (
      <DocumentTitle title='Expert search and listing | Atheneum Partners'>
        <div className='expert-search'>
          <ExpertSearchPanel />
          <Route path='/expert-search/expert/:id' component={ExpertPage} />
        </div>
      </DocumentTitle>
    )
  }
}

export default observer(ExpertSearchPage)
